
import cx from 'classnames'
import _ from '@/utils/lodash-optimized'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Outlet } from 'react-router-dom'
import IssueMapper from 'shared_src/mappings/issue'

import { withLegacyRouter } from '../../../decorators'
import { getRows, countIssuesByStatus, sidebarWrapper } from '../../../lib/issues'
import { notify } from '../../../lib/Notification/actions'
import {
  resetFormState,
  resetEncounterType
} from '../../Encounter/EncounterSummary/actions'
import { uid } from '../../igao/utils'
import { CircularProgress, Paper } from '../../shared/NarusMaterial'
import {
  showSidebar,
  closeSidebar,
  toggleSidebarFilter,
  updateIssue
} from '../IGAO/actions'
import CloseableIssuesWarningModal from '../IGAO/components/CloseableIssuesWarningModal'
import { IgaoComponent } from '../IGAO/components/IGAO'
import LeftNav from '../LeftNav'

import {
  navBarOpen,
  navBarClose
} from './actions'

import './styles.scss'

class Assessment extends React.Component {
  constructor (props) {
    super(props)
    this.navToggle = this.navToggle.bind(this)
    this.igaoToggleFilter = this.igaoToggleFilter.bind(this)
    this.igaoSave = this.igaoSave.bind(this)
    this.igaoToggle = this.igaoToggle.bind(this)
  }

  componentDidMount () {
    const { dispatch } = this.props
    dispatch(navBarOpen())
    dispatch(resetFormState())
    dispatch(resetEncounterType())
    this.checkEncounterPresence(this.props)
  }

  componentDidUpdate () {
    this.checkEncounterPresence(this.props)
  }

  checkEncounterPresence (props) {
    const {
      encounterId,
      encounterFetched,
      encounterSigned,
      encounterSigning,
      encounterAuthor,
      roles,
      userId,
      params: { clientName, id },
      navigate
    } = props

    const role = roles[`${clientName}-compassion`]
    const { dispatch } = this.props
    const isNotAuthor = encounterAuthor !== userId || !encounterId
    const isAdmin = [ 'administrator', 'executive_director', 'medical_director' ].includes(role)
    const encounterFetchedAndIsNotAuthor = isNotAuthor && encounterFetched && !isAdmin

    if (
      (encounterFetchedAndIsNotAuthor &&
      !encounterSigned &&
      !encounterSigning) ||
      (!encounterId && encounterFetched)
    ) {
      navigate(`/patient/${clientName}/${id}/patientFolder`)
      dispatch(
        notify(
          'Please open an encounter with this patient to view the assessment'
        )
      )
    }
  }

  navToggle () {
    const { encounterNavBar, dispatch } = this.props
    if (!encounterNavBar.open) {
      dispatch(navBarOpen())
    } else if (encounterNavBar.open) {
      dispatch(navBarClose())
    }
  }

  igaoToggle () {
    const { sidebar, dispatch } = this.props
    if (sidebar.open) {
      dispatch(closeSidebar())
    } else {
      dispatch(showSidebar())
    }
  }

  igaoToggleFilter (filter) {
    const { dispatch } = this.props
    dispatch(toggleSidebarFilter(filter))
  }

  igaoSave (data) {
    const { currentUser, encounterId, dispatch } = this.props
    const carePlanAndGoal = IssueMapper.mapFormToIssue({
      issue: data,
      currentUser,
      encounterId,
      uid
    })
    dispatch(updateIssue(carePlanAndGoal))
  }

  renderSidebar () {
    const { encounterNavBar } = this.props

    return (
      <div
        className={cx('assessment-sidebar', {
          visible: encounterNavBar.open
        })}
      >
        <Paper
          height='100%'
          noPadding
          noBackground
          style={{ minHeight: '100%' }}
        >
          <CloseableIssuesWarningModal />
          {this.renderNav()}
        </Paper>
      </div>
    )
  }

  renderNav () {
    const {
      location: { pathname },
      params: { id, clientName },
      roles,
      encounterType,
      globalVars,
      encounterNavBar
    } = this.props
    const activeUrl = pathname && `/${_.last(pathname.split('/'))}`
    return (
      <LeftNav
        permissions={globalVars.permissions}
        active={activeUrl}
        patientId={id}
        clientName={clientName}
        encounterType={encounterType}
        roles={roles}
        visible={encounterNavBar.open}
        toggle={this.navToggle}
      />
    )
  }

  renderIgaoSidebar () {
    const {
      sidebar,
      careplans,
      goals,
      encounterId,
      esasData,
      location,
      dispatch,
      currentUser
    } = this.props
    const wrapper = sidebarWrapper(sidebar, location)
    if (wrapper.visible) {
      const issueFilters = Object.keys(wrapper.filters)
        .filter(
          key => wrapper.filters[key]
        )
      const filtered = _.filter(careplans, issue => {
        const { identifier } = issue
        const id = identifier.find(i => i.type.text === 'IssueID')
          .value
        const domain = identifier.find(i => i.type.text ===
            'DomainID')
          .value
        return wrapper.issues.find(i => i.id === id && i.domain ===
          domain)
      })
      const rows = getRows({
        issueFilters,
        careplans: filtered,
        goals,
        encounterId,
        esasData
      })
      const issueCounts = countIssuesByStatus({ careplans: filtered })
      const className = wrapper.open
        ? 'assessment-sidebar sidebar-displayed igao'
        : 'assessment-sidebar sidebar-hidden igao'
      return (
        <div className={className}>
          <Paper
            height='100%'
            noPadding
            style={{ minHeight: '100%' }}
          >
            <div className='igao-sidebar'>
              <div className='sidebar-content'>
                <IgaoComponent
                  dispatch={dispatch}
                  filters={issueFilters}
                  updateFilters={this.igaoToggleFilter}
                  rows={rows}
                  onSave={this.igaoSave}
                  currentUser={currentUser}
                  issueCounts={issueCounts}
                />
              </div>
              <button
                className='sidebar-toggle no-hide'
                onClick={this.igaoToggle}
              >
                <i className='fa fa-chevron-right' />
              </button>
            </div>
          </Paper>
        </div>
      )
    }
    return null
  }

  renderContent () {
    const { paused, sidebar, location } = this.props
    const wrapper = sidebarWrapper(sidebar, location)

    const className = 'assessment-body none-bg'

    const sidebarClassName = wrapper.open
      ? 'sidebar-toggle sidebar-toggle-hidden left'
      : 'sidebar-toggle left'

    return (
      <div className={className}>
        {paused ? <PausedContainer /> : <div><Outlet /></div>}
        {wrapper.visible && (
          <button
            className={sidebarClassName}
            onClick={this.igaoToggle}
          >
            <i className='fa fa-chevron-left' />
          </button>
        )}
      </div>
    )
  }

  render () {
    const { loading } = this.props
    if (loading) {
      return <CircularProgress />
    }

    return (
      <div className='assessment'>
        {this.renderSidebar()}
        {this.renderContent()}
        {this.renderIgaoSidebar()}
      </div>
    )
  }
}

Assessment.contextTypes = {
  router: PropTypes.instanceOf(Object)
}

const mapStateToProps = redux => ({
  globalVars: redux.globalVars,
  encounterNavBar: redux.encounterNavBar,
  loading: redux.patient.loading,
  patientId: redux.globalVars.params?.id,
    encounterId: redux?.encounter?.encounter?.id,
    encounterType: redux?.encounter?.encounter?.document?.type,
    paused: redux?.encounter?.encounter?.status === 'onleave',
    encounterSigned: redux?.encounter?.signed,
    encounterSigning: redux?.encounter?.encounter?._signing,
    encounterFetched: redux?.encounter?.fetched,
    encounterAuthor: redux?.encounter?.encounter?.author_id,
    userId: redux?.auth?.profile?.sub,
    roles: redux?.auth?.profile?.app_metadata?.roles,
  sidebar: redux.igao.sidebar,
  esasData: redux.esas.bannerData,
  currentUser: redux.users.current_user,
    patient: redux?.patient,
    careplans: redux?.patient?.compartment?.CarePlan ?? {},
    goals: redux?.patient?.compartment?.Goal ?? {}
})

function PausedContainer () {
  return (
    <div className='empty-assessment'>
      <h2>Encounter is Paused</h2>
    </div>
  )
}

export default connect(mapStateToProps)(withLegacyRouter(Assessment))
